<template>
  <li>
    <!-- Check both start and datetime params to add active class -->
    <a
      :class="{
        'is-Active': searchParams.start_datetime === item.start && searchParams.end_datetime === item.end,
      }"
      @click="filter({ start_datetime: item.start, end_datetime: item.end })"
      >{{ $store.getters.getStringTranslation(item.label.replace(/\s/g, '').toLowerCase()) }}</a
    >
  </li>
</template>

<script>
export default {
  name: 'FilterDate',
  props: ['item', 'searchParams', 'filter'],
}
</script>
